import { Col, Form, InputNumber, Row, type FormInstance } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Duration } from '@client/components/price/Range/Duration';
import { requiredField } from '@client/utils/form.util';
import { flexLayout } from '@client/utils/layout.util';
import { EDurationTypes, utilityCounter } from '@common/types';

export interface IFeatureUtilityProps {
  disabled?: boolean;
  loading?: boolean;
  formRef?: FormInstance;
}

export const FeatureUtility: React.FC<IFeatureUtilityProps> = ({
  disabled,
  formRef,
}) => {
  const { t } = useTranslation();

  // Watch for isUtilityEnabled on the form
  const isUtilityEnabled = Form.useWatch('isUtilityEnabled', formRef);

  if (!isUtilityEnabled) {
    return (
      <div
        style={{ color: 'var(--ant-text-color-secondary)', padding: '8px 0' }}
      >
        {t(
          'feature.utility.disabledMessage',
          'Utility limits are disabled for this feature.',
        )}
      </div>
    );
  }

  return (
    <Row gutter={[24, 0]}>
      <Col {...flexLayout.halfColumn}>
        <Form.Item
          name={[utilityCounter, 'counter']}
          label={t('feature.utility.counter')}
          rules={[requiredField(t('feature.utility.counter'), true)]}
        >
          <InputNumber
            min={1}
            style={{ width: '100%' }}
            disabled={disabled}
            placeholder={t('form.inputPlaceholder', {
              field: t('feature.utility.counter'),
            })}
          />
        </Form.Item>
      </Col>
      <Col {...flexLayout.halfColumn}>
        <Duration
          label={t('feature.utility.duration')}
          disabled={disabled || false}
          prefix={[utilityCounter]}
          namespace="duration"
          exclude={['HOUR', 'FOREVER']}
          required={true}
          durationTypes={
            Object.keys(EDurationTypes) as (keyof typeof EDurationTypes)[]
          }
        />
      </Col>
    </Row>
  );
};
